@if (breadcrumbs.length > 1) {
  <div class="breadcrumb-container">
    @for (crumb of breadcrumbs; track crumb.path ?? $index; let last = $last) {
      @if (!last && crumb.path) {
        <a [routerLink]="crumb.path.startsWith('/') ? crumb.path : '/' + crumb.path"
          [queryParams]="crumb.queryParams"
          class="breadcrumb-link">
          {{ crumb.label }}
        </a>
      }
      @else {
      <span class="current-page">{{ crumb.label }}</span>
    }
    @if (!last) {
      <lib-svg-icon [svgName]="chevronRightIcon" class="breadcrumb-chevron"
        [svgHeight]="'15px'"
        [svgWidth]="'11px'">
      </lib-svg-icon>
    }
  }
</div>
}